import React from 'react';
import reactStringReplace from 'react-string-replace';
import { getErrorMessage } from '../../utils/ErrorUtil';
import { Components } from '../../common/interfaces';
import { ContentDisplayMode } from './interfaces';
import { DataTestAttributes } from './constants';
import { Strings } from './strings';
import { TermsLink } from './styled';
export var isContentAvailable = function isContentAvailable(content, contentDisplayMode, onError) {
  if (content && (!content.contentTitle || !content.link || contentDisplayMode === ContentDisplayMode.INLINE && !content.backButtonText)) {
    onError(getErrorMessage(Components.TERMS_AND_CONDITIONS, Strings.MISSING_CONTENT_ERROR));
    return false;
  }
  return true;
};
export var parseTncPromptText = function parseTncPromptText(_ref) {
  var tncLinkInfo = _ref.tncLinkInfo,
    cheggTermsOfUseLink = _ref.cheggTermsOfUseLink,
    privacyPolicyLink = _ref.privacyPolicyLink,
    price = _ref.price,
    priceWithDiscount = _ref.priceWithDiscount,
    cheggTermsOfUseText = _ref.cheggTermsOfUseText,
    privacyPolicyText = _ref.privacyPolicyText,
    ctaLabel = _ref.ctaLabel,
    planDuration = _ref.planDuration,
    frequency = _ref.frequency;
  var tncPromptHtml = [];
  tncPromptHtml = parseStaticLink({
    text: [tncLinkInfo.tncPromptText],
    textToBeReplaced: '${cheggTermsOfUse}',
    url: cheggTermsOfUseLink,
    urlText: cheggTermsOfUseText,
    dataTestAttributes: DataTestAttributes.TERMS_OF_USE,
    linkClickAction: tncLinkInfo.linkClickAction
  });
  tncPromptHtml = parseStaticLink({
    text: tncPromptHtml,
    textToBeReplaced: '${privacyPolicy}',
    url: privacyPolicyLink,
    urlText: privacyPolicyText,
    dataTestAttributes: DataTestAttributes.PRIVACY_POLICY,
    linkClickAction: tncLinkInfo.linkClickAction
  });
  tncPromptHtml = parseTncLink({
    text: tncPromptHtml,
    termsTitle: tncLinkInfo.termsTitle,
    linkClickAction: tncLinkInfo.linkClickAction,
    tncLinkRef: tncLinkInfo.tncLinkRef
  });
  tncPromptHtml = parsePrice(tncPromptHtml, '${price}', price);
  tncPromptHtml = parsePrice(tncPromptHtml, '${priceWithDiscount}', priceWithDiscount);
  tncPromptHtml = parsePrice(tncPromptHtml, '${planDuration}', planDuration);
  tncPromptHtml = parsePrice(tncPromptHtml, '${frequency}', frequency);
  tncPromptHtml = parsePrice(tncPromptHtml, '${cta}', ctaLabel);
  tncPromptHtml = parseStaticLink({
    text: [tncPromptHtml, tncLinkInfo.upiTou ? "\n\n".concat(tncLinkInfo.upiTou) : ''],
    textToBeReplaced: '${upiVendorPrivacyPolicy}',
    url: tncLinkInfo.upiVendorPrivacyPolicyUrl || '',
    urlText: tncLinkInfo.upiVendorPrivacyPolicyText,
    dataTestAttributes: DataTestAttributes.BILLDESK_PRIVACY_POLICY,
    linkClickAction: tncLinkInfo.linkClickAction
  });
  return tncPromptHtml;
};
export var parseStaticLink = function parseStaticLink(_ref2) {
  var text = _ref2.text,
    textToBeReplaced = _ref2.textToBeReplaced,
    url = _ref2.url,
    _ref2$urlText = _ref2.urlText,
    urlText = _ref2$urlText === void 0 ? url : _ref2$urlText,
    dataTestAttributes = _ref2.dataTestAttributes,
    linkClickAction = _ref2.linkClickAction;
  return reactStringReplace(text, textToBeReplaced, function () {
    return /*#__PURE__*/React.createElement(TermsLink, {
      href: url,
      target: '_blank',
      "data-test": dataTestAttributes,
      onClick: function onClick(e) {
        linkClickAction(e, urlText, false);
      }
    }, urlText);
  }).flat();
};
export var parseTncLink = function parseTncLink(_ref3) {
  var text = _ref3.text,
    termsTitle = _ref3.termsTitle,
    linkClickAction = _ref3.linkClickAction,
    tncLinkRef = _ref3.tncLinkRef;
  return reactStringReplace(text, '${cheggStudyPackTerms}', function () {
    return /*#__PURE__*/React.createElement(TermsLink, {
      "data-test": DataTestAttributes.TERMS_AND_CONDITIONS_LINK,
      onClick: function onClick(e) {
        linkClickAction(e, termsTitle, true);
      },
      href: '#' // required to make the link accessible
      ,
      ref: tncLinkRef
    }, termsTitle);
  }).flat();
};
export var parsePrice = function parsePrice(text, textToBeReplaced, price) {
  return reactStringReplace(text, textToBeReplaced, function () {
    return /*#__PURE__*/React.createElement("span", null, price);
  }).flat();
};
export var getTncPromptText = function getTncPromptText(_ref4) {
  var isCouponApplied = _ref4.isCouponApplied,
    billingCycleContentKey = _ref4.billingCycleContentKey,
    tncPromptText = _ref4.tncPromptText,
    tncPromptTextWithCoupon = _ref4.tncPromptTextWithCoupon,
    tncPromptTextWithDuration = _ref4.tncPromptTextWithDuration;
  if (isCouponApplied && tncPromptTextWithCoupon) {
    return tncPromptTextWithCoupon;
  }
  if (billingCycleContentKey && tncPromptTextWithDuration) {
    return tncPromptTextWithDuration;
  }
  return tncPromptText;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/TermsAndConditions/helper.js
// module id = 1391
// module chunks = 11